import {Container, BoxInfo, BeerImage, LeftSide, RightSide} from "../CardBeer/style"
import {ContainerDeleteButton} from "./style"

import {ISelectedBeerProps} from "../../interfaces/index"


interface IDeleteBeerProps {
    beer: ISelectedBeerProps
    deleteBeer: (beer: ISelectedBeerProps) => void
}


export const DeleteBeer = ({beer, deleteBeer}: IDeleteBeerProps) => {
    return (
        <Container>
            <BoxInfo>
                <LeftSide>
                    <BeerImage>
                        <img src={beer.image_url} alt={beer.name} />    
                    </BeerImage> 
                </LeftSide>
                <RightSide>
                    <div className="beerName">
                        <p>{beer.name}</p>
                    </div>
                    <div className="beerDescription">
                        <p>{beer.description}</p>
                    </div>
                </RightSide>
            </BoxInfo>
            <ContainerDeleteButton>
                <button type="button" onClick={() => deleteBeer(beer)}>Deletar</button>
            </ContainerDeleteButton>
        </Container>
    )
}
